var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.128,
    height: 73.392,
    viewBox: "0 0 49.128 73.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(-22.118 -226.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>",
    transform: "translate(22.118 226.14)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_",
    "data-name": "<Compound Path>",
    d: "M53.2,226.774c-7.809.492-14.757,4.981-19.738,11.129a53.736,53.736,0,0,0-8.547,16.171,44.4,44.4,0,0,0-1.045,24.042c1.6,7.133,5.718,16.417,12.79,19.861a15.613,15.613,0,0,0,18.754-4.612c6.395-7.871,6.272-17.524,7.686-27.055a55.321,55.321,0,0,1,3.013-11.252c2.091-5.473,6.026-11.314,4.735-17.34-1.353-6.087-7.5-10.084-13.466-10.822a23.773,23.773,0,0,0-4.181-.123Z",
    transform: "translate(-22.341 -226.369)",
    fill: "#8e453c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_2",
    "data-name": "<Compound Path>",
    d: "M42.767,299.532a14.611,14.611,0,0,1-6.456-1.476c-7.071-3.382-11.375-12.605-13.035-20.107a45.365,45.365,0,0,1,1.045-24.226,53.044,53.044,0,0,1,8.67-16.233c5.411-6.825,12.544-10.822,19.922-11.314a25.175,25.175,0,0,1,4.3.123c5.78.676,12.359,4.735,13.773,11.068.984,4.735-1.045,9.223-3.013,13.589-.615,1.414-1.23,2.705-1.722,4a59.944,59.944,0,0,0-3.013,11.191c-.246,1.783-.43,3.566-.676,5.35-.922,7.932-1.783,15.433-7.071,21.89A16.513,16.513,0,0,1,42.767,299.532ZM54.45,226.915H52.974c-7.194.492-14.081,4.366-19.43,11.006a51.711,51.711,0,0,0-8.485,16.048,44.391,44.391,0,0,0-1.045,23.8c1.66,7.379,5.78,16.356,12.605,19.615a14.088,14.088,0,0,0,6.149,1.414,15.725,15.725,0,0,0,12.113-5.9c5.165-6.272,6.026-13.65,6.948-21.521.184-1.722.43-3.566.676-5.349a56.974,56.974,0,0,1,3.074-11.314c.492-1.353,1.107-2.644,1.722-4.058,1.906-4.243,3.935-8.608,2.951-13.1-1.353-6.026-7.625-9.838-13.1-10.514q-1.353-.123-2.705-.123Z",
    transform: "translate(-22.118 -226.14)",
    fill: "#591d00",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_3",
    "data-name": "<Compound Path>",
    d: "M66.11,255.059A55.324,55.324,0,0,0,63.1,266.311c-1.414,9.531-1.291,19.184-7.686,27.055a15.612,15.612,0,0,1-18.754,4.612c-7.071-3.443-11.191-12.728-12.789-19.861a44.4,44.4,0,0,1,1.045-24.042A53.736,53.736,0,0,1,33.459,237.9c4.981-6.149,11.929-10.637,19.738-11.129a23.774,23.774,0,0,1,4.181.123c5.964.738,12.113,4.735,13.466,10.822C72.135,243.745,68.2,249.586,66.11,255.059ZM60.391,231.14c-5.411-2.89-12.789-1.045-17.77,1.845a31.724,31.724,0,0,0-9.654,9.1c-3.259,4.673-4.858,10.207-5.718,15.8-.861,5.964-1.353,12.175.492,17.955,1.107,3.259,3.259,7.5,5.841,9.777a11.628,11.628,0,0,0,10.023,2.89c4.058-.922,6.7-4.8,8.055-8.362,1.722-4.427,1.906-9.346,2.337-14.019a41.352,41.352,0,0,1,4.981-16.171C62.051,244.606,68.262,235.444,60.391,231.14Z",
    transform: "translate(-22.341 -226.369)",
    fill: "#8e453c",
    fillRule: "evenodd",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M70.968,246c-.184,3.259-1.353,6.272-3.812,8.117-1.968,1.476-4.12,2.521-5.841,4.366a17.366,17.366,0,0,0-3.628,6.026,21.563,21.563,0,0,0,.492,15.679c.676,1.6-.369,4.243-.8,5.78-.676,2.152-1.168,4.3-1.968,6.395-1.414,3.628-3.566,7.379-7.194,9.285a12.785,12.785,0,0,1-11.744.43c-3.935-2.029-6.825-5.657-8.977-9.469a39.431,39.431,0,0,1-4.8-17.832,49.287,49.287,0,0,0,1.168,10.76c1.6,7.133,5.718,16.417,12.79,19.861a15.613,15.613,0,0,0,18.754-4.612c6.395-7.871,6.272-17.524,7.686-27.055a55.32,55.32,0,0,1,3.013-11.252C68.078,257.314,71.767,251.718,70.968,246Z",
    transform: "translate(-22.342 -233.789)",
    fill: "#8e453c",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>",
    transform: "translate(36.143 22.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M88.94,263.5c-1.66.184-2.951,2.582-3.689,3.812a22.764,22.764,0,0,0-2.275,5.165,28.265,28.265,0,0,0-.8,3.074,26.385,26.385,0,0,0-.676,4.857c0,1.045.062,6.456,2.4,4.612,1.107-.984,1.23-2.828,1.476-4.181a48.181,48.181,0,0,1,2.583-9.715q.43-1.107.922-2.152a11.1,11.1,0,0,0,1.23-3.074c.123-.861,0-2.521-1.168-2.4Z",
    transform: "translate(-81.13 -263.12)",
    fill: "#d3d9b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_4",
    "data-name": "<Compound Path>",
    d: "M82.806,285.523h0a1.18,1.18,0,0,1-.861-.369c-1.107-1.107-1.045-4.612-1.045-4.981a26.7,26.7,0,0,1,.676-4.919q.369-1.66.8-3.136a21.822,21.822,0,0,1,2.337-5.227l.246-.492c.8-1.291,2.029-3.32,3.689-3.5a1.316,1.316,0,0,1,1.168.43,3.894,3.894,0,0,1,.43,2.4,9.179,9.179,0,0,1-.922,2.46q-.184.369-.307.676c-.369.8-.676,1.476-.922,2.152a48.408,48.408,0,0,0-2.582,9.654l-.123.615c-.184,1.291-.43,2.89-1.537,3.812a1.737,1.737,0,0,1-1.045.43Zm6.026-21.89h-.123c-1.23.184-2.337,1.967-3.074,3.2q-.184.246-.307.43a19.841,19.841,0,0,0-2.214,5.1q-.43,1.414-.8,3.075a24.964,24.964,0,0,0-.676,4.734c0,1.414.184,3.751.861,4.427.123.184.184.184.307.184h0a1.068,1.068,0,0,0,.615-.307c.861-.676,1.045-2.091,1.23-3.32a3.132,3.132,0,0,0,.061-.615,54.336,54.336,0,0,1,2.644-9.777c.307-.676.615-1.414.984-2.214a5.64,5.64,0,0,1,.307-.738,7.523,7.523,0,0,0,.861-2.214,2.754,2.754,0,0,0-.307-1.783.414.414,0,0,0-.369-.184Z",
    transform: "translate(-80.899 -262.889)",
    fill: "#ca9f75",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_3",
    "data-name": "<Path>",
    d: "M90.763,263.9A31.356,31.356,0,0,0,88,268.143a32.292,32.292,0,0,0-2.337,6.579,44.716,44.716,0,0,0-1.168,6.948,19.614,19.614,0,0,0-.123,3.812,5.677,5.677,0,0,0,.615-.307c1.107-.984,1.23-2.828,1.476-4.181a48.176,48.176,0,0,1,2.582-9.715q.43-1.107.922-2.152a11.1,11.1,0,0,0,1.23-3.074A2.939,2.939,0,0,0,90.763,263.9Z",
    transform: "translate(-46.072 -240.682)",
    fill: "#d3d9b6",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_4",
    "data-name": "<Path>",
    d: "M35.373,257.327A41.275,41.275,0,0,1,43.244,243a32.239,32.239,0,0,0-10.023,14.511c-2.152,6.825-3.566,15.618-.922,22.566C32.36,272.453,33.037,264.521,35.373,257.327Z",
    transform: "translate(-25.485 -232.633)",
    fill: "#8e453c",
    opacity: 0.6,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_5",
    "data-name": "<Group>",
    transform: "translate(22.118 226.14)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_6",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_5",
    "data-name": "<Compound Path>",
    d: "M53.2,226.774c-7.809.492-14.757,4.981-19.738,11.129a53.736,53.736,0,0,0-8.547,16.171,44.4,44.4,0,0,0-1.045,24.042c1.6,7.133,5.718,16.417,12.79,19.861a15.613,15.613,0,0,0,18.754-4.612c6.395-7.871,6.272-17.524,7.686-27.055a55.321,55.321,0,0,1,3.013-11.252c2.091-5.473,6.026-11.314,4.735-17.34-1.353-6.087-7.5-10.084-13.466-10.822a23.773,23.773,0,0,0-4.181-.123Z",
    transform: "translate(-22.341 -226.369)",
    fill: "#8e453c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_6",
    "data-name": "<Compound Path>",
    d: "M42.767,299.532a14.611,14.611,0,0,1-6.456-1.476c-7.071-3.382-11.375-12.605-13.035-20.107a45.365,45.365,0,0,1,1.045-24.226,53.044,53.044,0,0,1,8.67-16.233c5.411-6.825,12.544-10.822,19.922-11.314a25.175,25.175,0,0,1,4.3.123c5.78.676,12.359,4.735,13.773,11.068.984,4.735-1.045,9.223-3.013,13.589-.615,1.414-1.23,2.705-1.722,4a59.944,59.944,0,0,0-3.013,11.191c-.246,1.783-.43,3.566-.676,5.35-.922,7.932-1.783,15.433-7.071,21.89A16.513,16.513,0,0,1,42.767,299.532ZM54.45,226.915H52.974c-7.194.492-14.081,4.366-19.43,11.006a51.711,51.711,0,0,0-8.485,16.048,44.391,44.391,0,0,0-1.045,23.8c1.66,7.379,5.78,16.356,12.605,19.615a14.088,14.088,0,0,0,6.149,1.414,15.725,15.725,0,0,0,12.113-5.9c5.165-6.272,6.026-13.65,6.948-21.521.184-1.722.43-3.566.676-5.349a56.974,56.974,0,0,1,3.074-11.314c.492-1.353,1.107-2.644,1.722-4.058,1.906-4.243,3.935-8.608,2.951-13.1-1.353-6.026-7.625-9.838-13.1-10.514q-1.353-.123-2.705-.123Z",
    transform: "translate(-22.118 -226.14)",
    fill: "#591d00",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_7",
    "data-name": "<Compound Path>",
    d: "M66.11,255.059A55.324,55.324,0,0,0,63.1,266.311c-1.414,9.531-1.291,19.184-7.686,27.055a15.612,15.612,0,0,1-18.754,4.612c-7.071-3.443-11.191-12.728-12.789-19.861a44.4,44.4,0,0,1,1.045-24.042A53.736,53.736,0,0,1,33.459,237.9c4.981-6.149,11.929-10.637,19.738-11.129a23.774,23.774,0,0,1,4.181.123c5.964.738,12.113,4.735,13.466,10.822C72.135,243.745,68.2,249.586,66.11,255.059ZM60.391,231.14c-5.411-2.89-12.789-1.045-17.77,1.845a31.724,31.724,0,0,0-9.654,9.1c-3.259,4.673-4.858,10.207-5.718,15.8-.861,5.964-1.353,12.175.492,17.955,1.107,3.259,3.259,7.5,5.841,9.777a11.628,11.628,0,0,0,10.023,2.89c4.058-.922,6.7-4.8,8.055-8.362,1.722-4.427,1.906-9.346,2.337-14.019a41.352,41.352,0,0,1,4.981-16.171C62.051,244.606,68.262,235.444,60.391,231.14Z",
    transform: "translate(-22.341 -226.369)",
    fill: "#8e453c",
    fillRule: "evenodd",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_5",
    "data-name": "<Path>",
    d: "M70.968,246c-.184,3.259-1.353,6.272-3.812,8.117-1.968,1.476-4.12,2.521-5.841,4.366a17.366,17.366,0,0,0-3.628,6.026,21.563,21.563,0,0,0,.492,15.679c.676,1.6-.369,4.243-.8,5.78-.676,2.152-1.168,4.3-1.968,6.395-1.414,3.628-3.566,7.379-7.194,9.285a12.785,12.785,0,0,1-11.744.43c-3.935-2.029-6.825-5.657-8.977-9.469a39.431,39.431,0,0,1-4.8-17.832,49.287,49.287,0,0,0,1.168,10.76c1.6,7.133,5.718,16.417,12.79,19.861a15.613,15.613,0,0,0,18.754-4.612c6.395-7.871,6.272-17.524,7.686-27.055a55.32,55.32,0,0,1,3.013-11.252C68.078,257.314,71.767,251.718,70.968,246Z",
    transform: "translate(-22.342 -233.789)",
    fill: "#8e453c",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_7",
    "data-name": "<Group>",
    transform: "translate(36.143 22.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_6",
    "data-name": "<Path>",
    d: "M88.94,263.5c-1.66.184-2.951,2.582-3.689,3.812a22.764,22.764,0,0,0-2.275,5.165,28.265,28.265,0,0,0-.8,3.074,26.385,26.385,0,0,0-.676,4.857c0,1.045.062,6.456,2.4,4.612,1.107-.984,1.23-2.828,1.476-4.181a48.181,48.181,0,0,1,2.583-9.715q.43-1.107.922-2.152a11.1,11.1,0,0,0,1.23-3.074c.123-.861,0-2.521-1.168-2.4Z",
    transform: "translate(-81.13 -263.12)",
    fill: "#d3d9b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_8",
    "data-name": "<Compound Path>",
    d: "M82.806,285.523h0a1.18,1.18,0,0,1-.861-.369c-1.107-1.107-1.045-4.612-1.045-4.981a26.7,26.7,0,0,1,.676-4.919q.369-1.66.8-3.136a21.822,21.822,0,0,1,2.337-5.227l.246-.492c.8-1.291,2.029-3.32,3.689-3.5a1.316,1.316,0,0,1,1.168.43,3.894,3.894,0,0,1,.43,2.4,9.179,9.179,0,0,1-.922,2.46q-.184.369-.307.676c-.369.8-.676,1.476-.922,2.152a48.408,48.408,0,0,0-2.582,9.654l-.123.615c-.184,1.291-.43,2.89-1.537,3.812a1.737,1.737,0,0,1-1.045.43Zm6.026-21.89h-.123c-1.23.184-2.337,1.967-3.074,3.2q-.184.246-.307.43a19.841,19.841,0,0,0-2.214,5.1q-.43,1.414-.8,3.075a24.964,24.964,0,0,0-.676,4.734c0,1.414.184,3.751.861,4.427.123.184.184.184.307.184h0a1.068,1.068,0,0,0,.615-.307c.861-.676,1.045-2.091,1.23-3.32a3.132,3.132,0,0,0,.061-.615,54.336,54.336,0,0,1,2.644-9.777c.307-.676.615-1.414.984-2.214a5.64,5.64,0,0,1,.307-.738,7.523,7.523,0,0,0,.861-2.214,2.754,2.754,0,0,0-.307-1.783.414.414,0,0,0-.369-.184Z",
    transform: "translate(-80.899 -262.889)",
    fill: "#ca9f75",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_7",
    "data-name": "<Path>",
    d: "M90.763,263.9A31.356,31.356,0,0,0,88,268.143a32.292,32.292,0,0,0-2.337,6.579,44.716,44.716,0,0,0-1.168,6.948,19.614,19.614,0,0,0-.123,3.812,5.677,5.677,0,0,0,.615-.307c1.107-.984,1.23-2.828,1.476-4.181a48.176,48.176,0,0,1,2.582-9.715q.43-1.107.922-2.152a11.1,11.1,0,0,0,1.23-3.074A2.939,2.939,0,0,0,90.763,263.9Z",
    transform: "translate(-46.072 -240.682)",
    fill: "#d3d9b6",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_8",
    "data-name": "<Path>",
    d: "M35.373,257.327A41.275,41.275,0,0,1,43.244,243a32.239,32.239,0,0,0-10.023,14.511c-2.152,6.825-3.566,15.618-.922,22.566C32.36,272.453,33.037,264.521,35.373,257.327Z",
    transform: "translate(-25.485 -232.633)",
    fill: "#8e453c",
    opacity: 0.6,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeen);
export default __webpack_public_path__ + "static/media/been.6e8a7d487cd7245d2a521b24d6e94bf4.svg";
export { ForwardRef as ReactComponent };